import Overlay from "../../../Componentes/Overlay/index.js";
import Modal from "../../../Componentes/Utils/Modal";
import Formulario from "../../../Componentes/Utils/Formulario";
import FormComp from "../../../Componentes/FormComp";
import { formatBRLFromCents } from "../../../Funcoes/Money/index.jsx";
import { formatarData } from "../../../Funcoes/FormatarData";

function observacoesFromBm(bm) {
    if (!bm) return "";
    return bm.observacoes ?? bm.observacao ?? "";
}

function formatDataMedicao(bm) {
    if (!bm?.data_medicao) return "-";
    try {
        return formatarData(bm.data_medicao);
    } catch {
        return String(bm.data_medicao);
    }
}

const ModalDetalhesBM = ({ bm, fecharModal }) => {

    const statusNfDisplay = bm?.status_nf ?? "-";

    let emissaoDisplay = "-";
    if (bm?.emissao_nf) {
        try {
            emissaoDisplay = formatarData(bm.emissao_nf);
        } catch {
            emissaoDisplay = String(bm.emissao_nf);
        }
    }

    const preventSubmit = (e) => {
        e.preventDefault();
    };

    return (
        <Overlay state={true}>
            <Modal header close={fecharModal}>
                <Formulario onSubmit={preventSubmit}>
                    <FormComp
                        title="Nº BM"
                        type="text"
                        readOnly
                        valor={bm?.num_medicao ?? ""}
                    />
                    <FormComp
                        title="DATA MEDIÇÃO"
                        type="text"
                        readOnly
                        valor={formatDataMedicao(bm)}
                    />
                    <FormComp
                        title="VALOR"
                        type="text"
                        readOnly
                        valor={formatBRLFromCents(bm?.valor)}
                    />
                    <FormComp
                        title="STATUS NF"
                        type="text"
                        readOnly
                        valor={statusNfDisplay}
                    />
                    <FormComp
                        title="DATA EMISSÃO NF"
                        type="text"
                        readOnly
                        valor={emissaoDisplay}
                    />
                    <FormComp
                        title="FRS"
                        type="text"
                        readOnly
                        valor={bm?.frs ?? ""}
                    />
                    <FormComp
                        title="OBSERVAÇÕES"
                        type="textarea"
                        readOnly
                        valor={observacoesFromBm(bm)}
                    />
                </Formulario>
            </Modal>
        </Overlay>
    );
};

export default ModalDetalhesBM;
